import { useState, useRef, useEffect } from 'react';
import { Swal /*, SwalConfirm */ } from '@utils/alerts';
import moment from 'moment';

// Material UI
import {
  Container,
  Grid,
  Box,
  Typography,
  Button,
  TextField,
  Switch,
  Stack,
  InputAdornment,
} from '@mui/material';
import { AppRegistration, Search } from '@mui/icons-material';
import LoadingButton from '@mui/lab/LoadingButton';
import { Smartphone } from '@mui/icons-material';

// Componentes
import TextFieldTK from '@components/Form/TextFieldTK';

// Servicios
import EventsServices from '@services/EventsServices';

// Utils
import {
  isEmptyOrInvalidString,
  isNullOrUndefined,
  isEmptyOrNullObject,
  isTypePhone,
} from '@utils/validations';
import { getFormikUtil } from '@utils/Utilities';

// Utils
import { PATTERN_INE, PATTERN_CURP } from '@data/constants';

function SearchPeople(props) {
  const {
    catalogs,
    formik,
    dataEvent,
    setDataUser,
    datauser,
    dataPreguntas,
    setFlagNot,
    setFlagQuestion,
    register,
    loadingRegister,
    onlyMenores = false,
  } = props;

  const globalTypes = {
    INE: { name: 'user.INE', label: 'Clave de Elector', short: 'INE' },
    Celular: { name: 'contact.Celular', label: 'Celular', short: 'Celular' },
    Correo: { name: 'contact.Correo', label: 'Correo Electronico', short: 'Correo' },
  };

  const puedeRegistrarse = dataEvent.puedeRegistrarse === 1;

  const getFormik = (value) => getFormikUtil(formik, 'user', value);
  const getFormikC = (value = 'Celular') => getFormikUtil(formik, 'contact', value);

  useEffect(() => {
    if (onlyMenores && getFormik('isMenor')?.value === 0)
      formik.handleChange({ target: { name: 'user.isMenor', value: 1 } }); //eslint-disable-next-line
  }, [onlyMenores, formik.values?.user?.isMenor]);

  const [loadingIne, setLoadingIne] = useState(false);
  const [flagAccount, setFlagAccount] = useState(false);
  const [type, setType] = useState(globalTypes['Celular']);
  const botonRegistrar = useRef(null);

  useEffect(() => {
    if (!isEmptyOrNullObject(formik) && !formik?.touched?.user?.INE) {
      formik.setFieldTouched('user.INE', true);
      formik.setFieldTouched('contact.Celular', true);
      formik.setFieldTouched('contact.Correo', true);
    }
  }, [formik]);

  const onblurINE = (INEValue) => {
    setFlagAccount(false);
    setDataUser({ Nombre: '' });
    let genderId = '';
    let stateId = '';
    let dob = '';
    let len = INEValue.length;

    if (len >= 12) {
      let year = moment().format('YYYY');
      let dobAux = INEValue.substring(6, 12);
      let anio = dobAux.substring(0, 2);
      let mes = dobAux.substring(2, 4);
      let dia = dobAux.substring(4, 6);

      anio = moment(anio, 'YY').format('YYYY');

      let diff = parseInt(year) - parseInt(anio);

      if (diff > 0) dob = `${dia}/${mes}/${anio}`;
      else {
        anio = anio - 100;
        dob = `${dia}/${mes}/${anio}`;
      }
    }
    if (len >= 14) {
      let _sId = parseInt(INEValue.substring(12, 14));
      stateId = catalogs.entidades?.find((item) => item.value === _sId) ? _sId : '';
    }
    if (len >= 15) {
      const genderKey = INEValue.substring(14, 15);
      genderId = genderKey === 'M' ? 3 : genderKey === 'H' ? 2 : 1;
    }

    formik.setValues({
      ...formik.values,
      user: {
        ...formik.values.user,
        FechaNacimiento: moment(dob, 'DD/MM/YYYY'),
        idEstadoNacimiento: stateId,
        idSexo: genderId,
      },
    });
  };

  const onblurCurp = (CurpValue) => {
    let genderId = '';
    let dob = '';
    let len = CurpValue.length;

    if (len >= 12) {
      let year = moment().format('YYYY');
      let dobAux = CurpValue.substring(4, 10);
      let anio = dobAux.substring(0, 2);
      let mes = dobAux.substring(2, 4);
      let dia = dobAux.substring(4, 6);

      anio = moment(anio, 'YY').format('YYYY');

      let diff = parseInt(year) - parseInt(anio);

      if (diff > 0) dob = `${dia}/${mes}/${anio}`;
      else {
        anio = anio - 100;
        dob = `${dia}/${mes}/${anio}`;
      }
    }

    const fechaNacimientoDate = moment(dob, 'DD/MM/YYYY');
    const fechaActual = new Date();

    const edadMilisegundos = fechaActual - fechaNacimientoDate;
    const edadAnios = edadMilisegundos / (1000 * 60 * 60 * 24 * 365.25);

    if (edadAnios >= 19) {
      let messageCurp = 'La CURP pertenece a alguien mayor de edad';

      if (!onlyMenores) {
        messageCurp = messageCurp + ', coloque su Clave de Elector';
        formik.handleChange({ target: { name: 'user.isMenor', value: 0 } });
        formik.handleChange({ target: { name: 'user.CURP', value: '' } });
      }

      Swal.fire({ title: messageCurp, icon: 'warning' });
      return true;
    }

    if (len >= 10) {
      const genderKey = CurpValue.substring(10, 11);
      genderId = genderKey === 'M' ? 3 : genderKey === 'H' ? 2 : 1;
    }

    let CurpData = {
      ...formik.values,
      user: {
        ...formik.values.user,
        FechaNacimiento: moment(dob, 'DD/MM/YYYY'),
        idSexo: genderId,
      },
    };

    formik.setValues(CurpData);

    return CurpData;
  };

  const searchINE = async () => {
    let valorSearch = '';
    let Celular = '';
    let Correo = '';

    const isINE = type.short === 'INE';
    const isMenor = getFormik('isMenor')?.value === 1;

    switch (dataEvent.idModoEvento) {
      case 1:
      case 2:
      case 3:
        const INE = getFormik('INE');
        const CURP = getFormik('CURP');
        if (!isMenor && isINE && INE?.value?.length !== 18) {
          formik.handleChange({ target: { name: 'user.INE', value: '' } });
          return false;
        }

        if (isMenor && CURP?.value?.length !== 18) {
          formik.handleChange({ target: { name: 'user.CURP', value: '' } });
          return false;
        }

        if (!isMenor && isINE && INE?.error) return false;

        if (isMenor && CURP?.error) return false;

        if (isMenor) {
          valorSearch = CURP?.value;
          const result = onblurCurp(valorSearch);

          if (result === true) return false;
        } else valorSearch = INE?.value;

        Celular = getFormikC('Celular')?.value || '';
        Correo = getFormikC('Correo')?.value || '';
        break;
      case 4:
        Celular = getFormikC()?.value;

        if (!isEmptyOrInvalidString(Celular)) return false;
        if (!parseInt(Celular) && Celular?.length !== 10) {
          formik.handleChange({ target: { name: 'contact.Celular', value: '' } });
          return false;
        }

        break;
      default:
        break;
    }

    if (loadingIne) return false;

    try {
      setLoadingIne(true);
      setFlagAccount(false);
      setDataUser({});

      let result = await EventsServices.publicGetUser({
        INE: valorSearch,
        Celular,
        Correo,
        idEvento: formik.values?.idEvento,
      });
      const { results, response, message } = result;

      if (results) {
        const data = response?.data || {};

        if (!puedeRegistrarse && !response?.esta_registrado) {
          Swal.fire({
            title: `¡${data.NombreCompleto} no es posible registrarte en el evento, el preregistro ha concluído!`,
            icon: 'warning',
          });
          return;
        }

        setFlagAccount(true);
        if (botonRegistrar.current) botonRegistrar.current.scrollIntoView({ behavior: 'smooth' });

        setFlagQuestion(response?.pedir_cuestionario);
        setDataUser({ ...data, pedir_cuestionario: response?.pedir_cuestionario });
      } else if (dataEvent.TienePreregistro === 1 && puedeRegistrarse) {
        setFlagQuestion(dataPreguntas?.length > 0 ? true : false);
        setFlagNot(true);
        setFlagAccount(false);
        setDataUser({});
        /* // Pregunta si quiere intentar de nuevo la busqueda
        await SwalConfirm({
          title: message,
          text: `¿Quieres intentar buscar nuevamente?`,
          buttonText: 'Si, Buscar',
          cancelText: 'No, Registrarme',
          OnConfirm: () => {
            formik.setValues({
              ...formik.values,
              user: { ...formik.values.user, INE: '' },
              contact: { ...formik.values.contact, Celular: '', Correo: '' },
            });
          },
          OnCancel: () => {
            setFlagQuestion(dataPreguntas?.length > 0 ? true : false);
            setFlagNot(true);
            setFlagAccount(false);
            setDataUser({});
          },
        }); */
      } else if (!puedeRegistrarse) {
        Swal.fire({
          title: '¡No es posible registrarse en el evento, el preregistro ha concluído!',
          icon: 'warning',
        });
      } else throw new Error(message);
    } catch (e) {
      Swal.fire({ title: e.message, icon: 'warning' });
    } finally {
      setLoadingIne(false);
    }
  };

  const onChange = (e) => {
    setFlagAccount(false);
    setDataUser({ message: '' });

    let { value } = e.target;
    let local = { type: 'INE', INE: '', Celular: '', PIN: '', Correo: '' };

    // Si comienza con un número, es un celular
    if (/^\d/.test(value)) local = { type: 'Celular', Celular: value, PIN: value?.substring(0, 5) || '' };
    // Si contiene '@', es un correo o si después de la 6ª letra NO hay números, es un correo
    else if (value.includes('@') || /^[A-Za-z]{6}[^\d]/.test(value)) {
      value = value?.toLowerCase() || '';
      local = { type: 'Correo', Correo: value };
    }
    // Si no coincide con nada, asumimos que sigue siendo una INE en construcción
    else {
      value = value?.toUpperCase() || '';
      local = { type: 'INE', INE: value };
    }

    formik.setValues({
      ...formik.values,
      user: { ...formik.values.user, INE: local?.INE || '' },
      contact: { ...formik.values.contact, Celular: local?.Celular || '', Correo: local?.Correo || '' },
      account: { ...formik.values.account, PIN: local?.PIN || '' },
    });

    setType(globalTypes[local.type]);
  };

  const onChangeCURP = (e) => {
    setFlagAccount(false);
    setDataUser({ message: '' });

    let { value } = e.target;

    formik.setValues({
      ...formik.values,
      user: { ...formik.values.user, INE: '', CURP: value?.toUpperCase() || '' },
      contact: { ...formik.values.contact, Celular: '', Correo: '' },
      account: { ...formik.values.account, PIN: '' },
    });
  };

  const onSwitch = (e) => {
    formik.handleChange({ target: { name: 'user.isMenor', value: onlyMenores ? 1 : e ? 1 : 0 } });
    if (!e) formik.handleChange({ target: { name: 'user.INE', value: '' } });
    else formik.handleChange({ target: { name: 'user.CURP', value: '' } });
  };

  const handleRegister = (e) => {
    if (
      [3, 4].includes(dataEvent.idModoEvento) &&
      dataPreguntas.length > 0 &&
      datauser.pedir_cuestionario &&
      puedeRegistrarse
    ) {
      setFlagQuestion(true);
    } else register();
  };

  const handleForm = () => {
    if ([3, 4].includes(dataEvent.idModoEvento) && dataPreguntas.length > 0) {
      setFlagNot(true);
      setFlagQuestion(true);
    } else {
      setFlagNot(true);
      setFlagQuestion(false);
    }
  };

  const varFormik = (value) => (value === 'INE' ? getFormik(value) : getFormikC(value));

  return (
    <Box component="section" pt={6} my={6} sx={{ alignItems: 'center' }}>
      {Object.keys(dataEvent).length > 0 && (
        <Container>
          <Grid container sx={{ alignItems: 'center' }}>
            <Grid item md={12} sx={{ ml: { xs: 0, lg: 3 }, mb: { xs: 12, md: 0 } }}>
              <Typography
                variant="h5"
                color={'primary'}
                fontWeight="bold"
                sx={{ fontFamily: 'initial' }}
              >{`${dataEvent.Actividad}`}</Typography>
              <Typography variant="body1" color="text" mt={1} mb={onlyMenores ? 1 : 3}>
                {dataEvent.idModoEvento === 4 ? (
                  <>
                    Para registrarte en el evento, por favor escribe tu celular y da clic en el botón buscar
                  </>
                ) : (
                  `Para registrarte en el evento, por favor escribe tu ${
                    getFormik('isMenor')?.value ? 'curp' : 'clave de elector'
                  } y da clic en el botón buscar`
                )}
              </Typography>

              {onlyMenores && (
                <Typography variant="body1" color="text" mb={3}>
                  Solo se pueden registrar menores de edad
                </Typography>
              )}

              {!onlyMenores && dataEvent.AceptaMenores === 1 && dataEvent.idModoEvento === 3 && (
                <Stack direction="column" justifyContent="center" spacing={0.5}>
                  <Typography variant="body2" color="#FE9A2E">
                    ¿Es Menor de Edad?
                  </Typography>
                  <Stack direction="row" spacing={0.5}>
                    <Typography variant="subtitle1" color="primary">
                      No
                    </Typography>
                    <Switch
                      color="primary"
                      onChange={(e) => onSwitch(e.target.checked)}
                      checked={getFormik('isMenor')?.value === 1 ? true : false}
                    />
                    <Typography variant="subtitle1" color="primary">
                      Si
                    </Typography>
                  </Stack>
                </Stack>
              )}
              <Grid container sx={{ mt: 2 }} spacing={1}>
                <Grid item xs={12} sm={8} md={8}>
                  {getFormik('isMenor')?.value ? (
                    <TextField
                      required
                      fullWidth
                      type="text"
                      id="CURP_SEARCH"
                      name="user.CURP"
                      label="CURP"
                      placeholder="CURP"
                      value={getFormik('CURP')?.value?.toUpperCase()}
                      pattern={PATTERN_CURP}
                      onChange={onChangeCURP}
                      onBlur={(e) => onblurCurp(e.target.value)}
                      error={getFormik('CURP')?.error}
                      helperText={getFormik('CURP')?.helperText}
                    />
                  ) : dataEvent.idModoEvento !== 4 ? (
                    <TextFieldTK
                      required
                      fullWidth
                      type="text"
                      name={type.name}
                      label="Ingresa tu INE, Celular o Correo"
                      placeholder="Clave Elector / Celular / Correo"
                      value={varFormik(type.short)?.value}
                      pattern={PATTERN_INE}
                      onChange={onChange}
                      onBlur={(e) => (type.short === 'INE' ? onblurINE(e.target.value) : '')}
                      error={varFormik(type.short)?.error}
                      helperText={varFormik(type.short)?.helperText}
                      toUpperCase={type.short === 'INE'}
                      toLowerCase={type.short === 'Correo'}
                      noSpaces
                    />
                  ) : (
                    <TextField
                      required
                      fullWidth
                      name="contact.Celular"
                      label="Celular"
                      placeholder="1234567890"
                      value={getFormikC()?.value}
                      onChange={({ target: { value, name } }) => {
                        if (isTypePhone(value)) onChange({ target: { value, name } });
                      }}
                      error={getFormikC()?.error}
                      helperText={getFormikC()?.helperText}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <Smartphone />
                          </InputAdornment>
                        ),
                      }}
                    />
                  )}
                </Grid>

                <Grid item xs={12} sm={4} md={4}>
                  <LoadingButton
                    color="primary"
                    variant="contained"
                    size="large"
                    onClick={searchINE}
                    disabled={
                      !getFormik('isMenor')?.value &&
                      dataEvent.idModoEvento !== 4 &&
                      varFormik(type.short)?.error
                    }
                    loading={loadingIne}
                    loadingPosition="start"
                    startIcon={<Search />}
                  >
                    <span>Buscar</span>
                  </LoadingButton>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <Grid container sx={{ mt: 5 }}>
            {flagAccount && puedeRegistrarse && (
              <Grid item xs={12} direction="row" justifyContent="center" alignItems="center">
                <Typography variant="h6" sx={{ color: '#FE9A2E' }} align="center">
                  HOLA {datauser.NombreCompleto}
                </Typography>
                <Typography align="center"> DESEAS ASISTIR AL EVENTO?, DA CLICK AL BOTON </Typography>
                <Stack sx={{ pt: 1 }} direction="row" spacing={2} justifyContent="center">
                  <br />
                  <LoadingButton
                    size="small"
                    color="primary"
                    onClick={handleRegister}
                    loading={loadingRegister}
                    loadingPosition="end"
                    endIcon={<AppRegistration />}
                    variant="contained"
                  >
                    <span>Registrarme</span>
                  </LoadingButton>
                </Stack>
              </Grid>
            )}

            {flagAccount && !puedeRegistrarse && (
              <Grid item xs={12} direction="row" justifyContent="center" alignItems="center">
                <Typography variant="h6" sx={{ color: '#FE9A2E' }} align="center">
                  HOLA {datauser.NombreCompleto}
                </Typography>
                <Typography align="center"> Para consultar su QR, DE CLICK AL BOTON </Typography>
                <Stack sx={{ pt: 1 }} direction="row" spacing={2} justifyContent="center">
                  <br />
                  <LoadingButton
                    size="small"
                    color="primary"
                    onClick={handleRegister}
                    loading={loadingRegister}
                    loadingPosition="end"
                    endIcon={<AppRegistration />}
                    variant="contained"
                  >
                    <span>Ver QR</span>
                  </LoadingButton>
                </Stack>
              </Grid>
            )}

            {!flagAccount && !getFormik('INE')?.error && isNullOrUndefined(datauser) && puedeRegistrarse && (
              <Grid item xs={12}>
                <Box align="center" sx={{ pt: 4, pb: 15 }}>
                  <Typography sx={{ color: '#FE9A2E' }} align="center">
                    No se encontraron resultados.
                  </Typography>
                  <Typography sx={{ color: '#FE9A2E' }} align="center">
                    Para tener acceso al EVENTO por favor
                    <br />
                    <Button variant="contained" size="medium" color="primary" onClick={handleForm}>
                      REGÍSTRATE AQUÍ.
                    </Button>
                    <br />
                    Es muy fácil.
                  </Typography>
                </Box>
              </Grid>
            )}

            {dataEvent.idModoEvento === 4 && (
              <Grid item xs={12}>
                <Typography align="center">
                  Si no te has registrado,
                  <Button size="small" color="primary" onClick={handleForm} sx={{ ml: 1 }}>
                    REGÍSTRATE AQUÍ.
                  </Button>
                </Typography>
              </Grid>
            )}
          </Grid>
        </Container>
      )}
    </Box>
  );
}

export default SearchPeople;
